import { render, staticRenderFns } from "./mailwhite-list.vue?vue&type=template&id=186742e8&"
import script from "./mailwhite-list.vue?vue&type=script&lang=js&"
export * from "./mailwhite-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "mailwhite-list.vue"
export default component.exports